module.exports = __webpack_public_path__ + "img/selected7-min.621e7ea3.png";